import { Modal } from './design-system/Modal';
import { promotionalTypesConfig } from 'data/shared/promotionalTypes';
import { PromotionalType } from 'data/shared/__autogenerated__/types/PromotionalType';

const BILT_SPEND_RATIO_TYPES: PromotionalType[] = [
  PromotionalType.BILT_SPEND_RATIO_25,
  PromotionalType.BILT_SPEND_RATIO_50,
  PromotionalType.BILT_SPEND_RATIO_75,
  PromotionalType.BILT_SPEND_RATIO_100,
];

export const BiltSpendRatioModal = ({
  handleClose,
  promotionalTypes,
  setPromotionalTypes,
}: {
  handleClose: () => void;
  promotionalTypes: PromotionalType[];
  setPromotionalTypes: (types: PromotionalType[]) => void;
}) => {
  const hasSelectedType = BILT_SPEND_RATIO_TYPES.some((type) =>
    promotionalTypes.includes(type)
  );

  return (
    <Modal
      isOpen={true}
      handleClose={handleClose}
      style={{ maxWidth: '400px' }}
    >
      <div style={{ marginBottom: '16px' }}>
        <h2 style={{ margin: '0 0 8px 0', fontSize: '18px' }}>
          Everyday spend ratio (% of housing)
        </h2>
        <p
          style={{
            fontSize: '14px',
            color: '#666',
            margin: 0,
          }}
        >
          Your housing points depend on how much you spend on everyday purchases
          relative to your monthly housing payment.
        </p>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        {/* None option */}
        <label
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            cursor: 'pointer',
          }}
        >
          <input
            type="radio"
            name="bilt_spend_ratio"
            checked={!hasSelectedType}
            onChange={() => {
              // Remove all Bilt spend ratio types
              const newTypes = promotionalTypes.filter(
                (t) => !BILT_SPEND_RATIO_TYPES.includes(t)
              );
              setPromotionalTypes(newTypes);
            }}
            style={{
              marginRight: '10px',
              marginTop: '4px',
              cursor: 'pointer',
            }}
          />
          <div>
            <div
              style={{
                fontFamily: 'Merriweather',
                color: '#000',
                fontSize: '14px',
              }}
            >
              None
            </div>
            <div
              style={{
                fontSize: '12px',
                color: '#666',
                marginTop: '2px',
              }}
            >
              No housing points earned
            </div>
          </div>
        </label>

        {/* Tier options */}
        {BILT_SPEND_RATIO_TYPES.map((promoType) => {
          const config = promotionalTypesConfig[promoType];
          if (!config || config.type === 'enum') {
            return null;
          }
          const isSelected = promotionalTypes.includes(promoType);
          return (
            <label
              key={promoType}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                cursor: 'pointer',
              }}
            >
              <input
                type="radio"
                name="bilt_spend_ratio"
                checked={isSelected}
                onChange={() => {
                  // Remove all Bilt spend ratio types, then add selected
                  const newTypes = promotionalTypes.filter(
                    (t) => !BILT_SPEND_RATIO_TYPES.includes(t)
                  );
                  setPromotionalTypes([...newTypes, promoType]);
                }}
                style={{
                  marginRight: '10px',
                  marginTop: '4px',
                  cursor: 'pointer',
                }}
              />
              <div>
                <div
                  style={{
                    fontFamily: 'Merriweather',
                    color: '#000',
                    fontSize: '14px',
                  }}
                >
                  {config.label}
                </div>
                {config.description && (
                  <div
                    style={{
                      fontSize: '12px',
                      color: '#666',
                      marginTop: '2px',
                    }}
                  >
                    {config.description}
                  </div>
                )}
              </div>
            </label>
          );
        })}
      </div>
    </Modal>
  );
};
